import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSunset: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSunset"><Path fillRule="evenodd" clipRule="evenodd" d="M3 13V12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12V13C17.2315 13 6.76846 13 3 13ZM1 15.5H23V17H1V15.5ZM6 19.5H18V21H6V19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSunset;
